/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClipDetailsResponse } from './clipDetailsResponse';
import { ClipTagResponse } from './clipTagResponse';
import { ManagementAuthorResponse } from './managementAuthorResponse';
import { ManagementMediumResponse } from './managementMediumResponse';
import { ManagementSentimentResponse } from './managementSentimentResponse';

export interface ManagementClipResponse { 
    id: string;
    url?: string;
    mediaUrl?: string;
    publicationDate?: Date;
    area?: string;
    pageNumber?: string;
    type?: ManagementClipResponse.TypeEnum;
    hasVideo?: boolean;
    main?: boolean;
    important?: boolean;
    source?: ManagementClipResponse.SourceEnum;
    sif?: number;
    medium?: ManagementMediumResponse;
    groupId?: string;
    autoGrouped?: boolean;
    aiAutoTagged?: boolean;
    externalId?: string;
    screenshotUrl?: string;
    visibilityIndex?: number;
    details?: Array<ClipDetailsResponse>;
    tags?: Array<ClipTagResponse>;
    authors?: Array<ManagementAuthorResponse>;
    transcribed?: boolean;
    createdAt?: Date;
    relatedCount?: number;
    sentiment?: ManagementSentimentResponse;
    clientId?: string;
    competitorOnly?: boolean;
    /**
     * Repeat TV airings (\"Повторени прилози\"): sorted \"HH:mm\" (Europe/Skopje), populated only when this clip aired more than once.
     */
    airingTimes?: Array<string>;
}
export namespace ManagementClipResponse {
    export type TypeEnum = 'NEUTRAL' | 'PROMOTIONAL' | 'ABUSIVE';
    export const TypeEnum = {
        NEUTRAL: 'NEUTRAL' as TypeEnum,
        PROMOTIONAL: 'PROMOTIONAL' as TypeEnum,
        ABUSIVE: 'ABUSIVE' as TypeEnum
    };
    export type SourceEnum = 'GRID' | 'FAXAL' | 'INOREADER' | 'DEFAULT' | 'COPY' | 'NEW_GROUP' | 'CLIPS' | 'MANUAL' | 'IMPORT' | 'FACEBOOK';
    export const SourceEnum = {
        GRID: 'GRID' as SourceEnum,
        FAXAL: 'FAXAL' as SourceEnum,
        INOREADER: 'INOREADER' as SourceEnum,
        DEFAULT: 'DEFAULT' as SourceEnum,
        COPY: 'COPY' as SourceEnum,
        NEWGROUP: 'NEW_GROUP' as SourceEnum,
        CLIPS: 'CLIPS' as SourceEnum,
        MANUAL: 'MANUAL' as SourceEnum,
        IMPORT: 'IMPORT' as SourceEnum,
        FACEBOOK: 'FACEBOOK' as SourceEnum
    };
}